if(document.querySelector(".banner .countdown") !== null){

    document.querySelectorAll(".banner .countdown").forEach(c => {

        var then = new Date(c.textContent)
        then = new Date(then.toLocaleString('en-US', { timeZone: 'America/New_York' })).getTime();
        let countdownExpired = false;
      
        function timer() {
          var now = new Date()
          now = new Date(now).getTime()
          var diff = then - now;
          if(diff < 0){
            countdownExpired = true;
          }
          var days = Math.floor(diff / (1000*60*60*24));
          var hours = Math.floor(diff % (1000*60*60*24) / (1000*60*60));
          var minutes = Math.floor(diff % (1000*60*60)/ (1000*60));
          var seconds = Math.floor(diff % (1000*60) / 1000);  
            
      
            // Adding the zeros.
            days <= 9 ? days = `0${days}` : days;
            hours <= 9 ? hours = `0${hours}` : hours;
            minutes <= 9 ? minutes = `0${minutes}` : minutes;
            seconds <= 9 ? seconds = `0${seconds}` : seconds;   
      
            if(countdownExpired){
                c.classList.add("countdown-expired");
                if(c.hasAttribute("data-success")){
                    c.innerHTML = c.getAttribute("data-success");
                } else {
                    c.innerHTML = ``;
                }
            } else {
                c.innerHTML = `${days > 0 ? `${days} days : ` : ""}${hours} hours : ${minutes} minutes : ${seconds} seconds`;
            }
      
        }
      
        timer();
        c.style.opacity = "1";
        if(!countdownExpired){
            setInterval(timer,1000);
        }

    })

  
  
  }
